// src/pages/News.jsx
import React from 'react';
import Slider from 'react-slick';
import { useTranslation } from '../context/TranslationContext';
import news1 from '../images/news1.jpg';
import news2 from '../images/news2.jpg';
import news3 from '../images/news3.jpg';

export default function News() {
  const { t } = useTranslation();

  const newsItems = [
    {
      id: 1,
      img: news1,
      title: t('news1_title'),
      desc: t('news1_description'),
      link: 'https://www.techradar.com/pro/generative-ai-the-catalyst-for-business-transformation',
      alt: t('news1_alt') || 'Noticias sobre inteligencia artificial en empresas',
    },
    {
      id: 2,
      img: news2,
      title: t('news2_title'),
      desc: t('news2_description'),
      link: 'https://www.xataka.com/robotica-e-ia/apple-tiene-opcion-clarisima-para-no-quedarse-atras-ia-comprar-anthropic',
      alt: t('news2_alt') || 'Crecimiento empresarial con inteligencia artificial',
    },
    {
      id: 3,
      img: news3,
      title: t('news3_title'),
      desc: t('news3_description'),
      link: 'https://www.openpr.com/news/3474967/digital-transformation-market-in-2025-ai-cloud-computing',
      alt: t('news3_alt') || 'Innovación con inteligencia artificial generativa',
    },
  ];

  const settings = {
    dots: true,
    arrows: false,
    autoplay: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <section id="noticias" className="py-16 bg-gray-200">
      <div className="container mx-auto px-4 sm:px-6 md:px-8">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-8 text-indigo-900">
          {t('news_title')}
        </h2>

        {/* Mobile carousel */}
        <div className="block md:hidden">
          <Slider {...settings}>
            {newsItems.map(({ id, img, title, desc, link, alt }) => (
              <div key={id} className="px-2">
                <article className="bg-white rounded-lg shadow-lg overflow-hidden p-4">
                  <img
                    src={img}
                    alt={alt}
                    loading="lazy"
                    className="w-full h-48 object-cover rounded-t-lg mb-4"
                  />
                  <h3 className="text-xl font-semibold mb-2 text-gray-900">
                    {title}
                  </h3>
                  <p className="text-gray-600 mb-4 text-base leading-relaxed">
                    {desc}
                  </p>
                  <a
                    href={link}
                    className="text-cyan-500 hover:underline text-sm"
                  >
                    {t('news_read_more')}
                  </a>
                </article>
              </div>
            ))}
          </Slider>
        </div>

        {/* Grid for desktop */}
        <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {newsItems.map(({ id, img, title, desc, link, alt }) => (
            <article key={id} className="bg-white rounded-lg shadow-lg overflow-hidden">
              <img
                src={img}
                alt={alt}
                loading="lazy"
                className="w-full h-48 object-cover"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2 text-gray-900">
                  {title}
                </h3>
                <p className="text-gray-600 mb-4 text-base leading-relaxed">
                  {desc}
                </p>
                <a
                  href={link}
                  className="text-cyan-500 hover:underline text-sm"
                >
                  {t('news_read_more')}
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}